<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import fieldVisibilityMixin from '../../../mixins/fieldVisibility';

export default {
  name: 'PrivacyAuditMainTab',
  components: {
    RbxRemoteCombobox,
  },
  mixins: [fieldVisibilityMixin],
  props: {
    privacyAudit: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      hiddenFieldsDomain: 'privacyAudit',
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<template>
  <div class="material-detail-tab main-tab">
    <v-layout row wrap>
      <v-flex lg8>
        <v-layout row wrap/>
      </v-flex>

      <v-flex lg4>
        <h4 class="material-detail-tab-title">xxxx</h4>
      </v-flex>
    </v-layout>
  </div>
</template>

<style lang="scss">
.main-tab {
  &-charts {
    margin-bottom: 40px;
    height: 200px;

    .highcharts-background {
      fill: transparent;
    }
  }
}
</style>
